import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { text: String }

  copy () {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.element.innerHTML
      this.element.innerHTML = '<span class="icon icon__share"></span> Copied!'
      setTimeout(() => {
        this.element.innerHTML = original
      }, 2000)
    })
  }
}
